import { useEffect } from 'react';
import { windowScrollTop } from 'helpers';

const useScrollTop = () => {
  useEffect(() => {
    windowScrollTop();
  }, []);
};

export default useScrollTop;
